import { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import LoadingScreen from "../components/LoadingScreen";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import HowItWorks from "../components/HowItWorks";
import GroomingSubscriptions from "../components/GroomingSubscriptions";
import ServicesGrid from "../components/ServicesGrid";
import OffersSection from "../components/OffersSection";
import WhyWoofsy from "../components/WhyWoofsy";
import Statistics from "../components/Statistics";
import Testimonials from "../components/Testimonials";
import BookingModal from "../components/BookingModal";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import { CursorPaws } from "../components/Effects";

export default function LandingPage() {
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const [selectedCoupon, setSelectedCoupon] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
    const id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  const book = (serviceName = "", couponCode = "") => {
    const safeService = typeof serviceName === "string" ? serviceName : "";
    const safeCoupon = typeof couponCode === "string" ? couponCode : "";
    setSelectedService(safeService);
    setSelectedCoupon(safeCoupon);
    setModalOpen(true);
  };

  return (
    <div className="relative">
      <AnimatePresence>{loading && <LoadingScreen onDone={() => setLoading(false)} />}</AnimatePresence>
      <CursorPaws />
      <Navbar onBook={book} />
      <Hero onBook={book} />
      <HowItWorks />
      <GroomingSubscriptions onBook={book} />
      <ServicesGrid onBook={book} />
      <OffersSection onBook={book} />
      <WhyWoofsy onBook={book} />
      <Statistics />
      <Testimonials />
      <FAQ />
      <Footer onBook={book} />

      <BookingModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        initialService={selectedService}
        initialCoupon={selectedCoupon}
      />
    </div>
  );
}
